import {
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
} from "./authActions";

const initState = {
  isAuthenticated: true,
  isError: false,
  errorMessage: "",
  user: {},
  isLoading: false,
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isError: false,
        errorMessage: "",
        isLoading: true,
      };
    case LOGOUT_REQUEST:
      localStorage.removeItem("id");
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        user: {},
      };
    case GET_USER_REQUEST:
      return {
        ...state,
        isError: false,
        errorMessage: "",
        isLoading: true,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        isError: false,
        errorMessage: "",
        isLoading: false,
        user: action.payload,
      };
    case GET_USER_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        isError: true,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
